import {
  SET_NOTIFICATION_CENTER_MODAL_STATE,
  SET_NOTIFICATION_CENTER_LOADING_STATE,
  FETCH_NOTIFICATIONS_ASYNC_SUCCESS,
  NOTIFICATIONS_ASYNC_ERROR,
  FETCH_INGREDIENT_ASYNC_ERROR,
  SET_SELECTED_NOTIFICATION,
  SET_NOTIFICATION_STEP,
} from 'actions/notifications';
import { source as SOURCE, notificationsCenterSteps } from 'constants/notifications';

const initialState = {
  isLoading: false,
  isError: false,
  message: '',
  isNotificationCenterOpen: false,
  source: SOURCE.NOTIFICATIONS,
  selectedNotification: {},
  step: notificationsCenterSteps.NOTIFICATIONS_STEP,
  data: [],
};

const actionsMap = {
  [SET_NOTIFICATION_CENTER_MODAL_STATE]: (state, action) => {
    const {
      isOpen,
      source,
    } = action.payload;

    return {
      ...state,
      isNotificationCenterOpen: isOpen,
      source,
    };
  },
  [SET_NOTIFICATION_CENTER_LOADING_STATE]: (state, action) => {
    return {
      ...state,
      isLoading: action.payload,
    };
  },
  [FETCH_NOTIFICATIONS_ASYNC_SUCCESS]: (state, action) => {
    return {
      ...state,
      data: action.payload,
      isError: false,
      message: '',
    };
  },
  [NOTIFICATIONS_ASYNC_ERROR]: (state, action) => {
    return {
      ...state,
      isError: true,
      message: action.payload,
    };
  },
  [FETCH_INGREDIENT_ASYNC_ERROR]: (state, action) => {
    return {
      ...state,
      isError: true,
      message: action.payload,
    };
  },
  [SET_SELECTED_NOTIFICATION]: (state, action) => {
    return {
      ...state,
      selectedNotification: action.payload.notification,
    };
  },
  [SET_NOTIFICATION_STEP]: (state, action) => {
    return {
      ...state,
      step: action.payload.step,
    };
  },
};

export default function notifications(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
